module.exports = ".content-header {\n    color: #4695d9;\n}\n"